<template>
  <div class="equipmentContrast mainPageBg"
    v-loading="$store.state.user.loadingState">
    <div class="leftMenuBox">
      <ComparisonTree @ECchangeTree="ECchangeTree" />
    </div>
    <div class="rightBox">
      <div class="chartsBox">
        <div class="leftChart">
          <PublicEcharts :id="'myCharts'"
            :chartsData="chartsData"
            :type="'lightLine'" />
        </div>
        <div class="rightChart ashComWrap">
          <div class="comTitle">
            <el-radio-group v-model="barActive"
              size="mini"
              @change="handleBarData">
              <el-radio-button label="average">平均值</el-radio-button>
              <el-radio-button label="max">最大值</el-radio-button>
              <el-radio-button label="min">最小值</el-radio-button>
            </el-radio-group>
          </div>
          <div class="comContentBox">
            <PublicEcharts :id="'barCharts'"
              :chartsData="barChartsData"
              :type="'horizontalBar'" />
          </div>
        </div>
      </div>
      <div class="tableBox">
        <div class="comTitle">
          <span></span>
          <el-button type="primary"
            size="mini"
            plain
            style="margin-right: 20px"
            @click="exportExcel"
            v-if="judgeAuthority('shebei:equipmentContrast:export')"><i class="el-icon-download el-icon--left"></i>EXCEL</el-button>
        </div>
        <el-table :data="tableData"
          id="exportTab"
          border
          stripe
          height="90%"
          style="width: 98%;margin:0 auto"
          :header-cell-style="{
            'background-color': '#F7F7F7',
          }"
          size="mini">
          <el-table-column prop="time"
            v-if="tabHead.length"
            label="时间"
            width="120"
            align="center">
          </el-table-column>
          <el-table-column v-for="(v, i) in tabHead"
            :key="i"
            :prop="v.prop"
            :label="v.label"
            align="center"
            :formatter="$setTabNumber"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import ComparisonTree from "@/components/shebeiguanli/ComparisonTree";
import PublicEcharts from "@/components/PublicEcharts";
import api from "@/api";
import { dateFtt, judgeAuthority, exportExcelFun } from "@/assets/js/utils";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
export default {
  components: {
    ComparisonTree,
    PublicEcharts,
  },
  data() {
    return {
      tableData: [],
      tabHead: [],
      barActive: "average",
      barChartsData: {
        showDownload: false,
        name: "",
        unit: "kw·h",
        xData: [],
        yData: [],
      },
      chartsData: { title: "设备对比", unit: "kw·h", xData: [], dataArr: [] },
      barAllData: [],
      formData: {},
      excelTitle: "",
    };
  },
  methods: {
    judgeAuthority,
    ECchangeTree(val) {
      this.excelTitle = `${val.name}对比(${
        val.timeValue ? val.timeValue : "全部"
      })`;
      this.tabHead = [];
      let treeList = [];
      if (val.treeValue && val.treeValue.length) {
        val.treeValue.map((v) => {
          this.tabHead.push({ label: v.name, prop: v.name });
          treeList.push({ id: v.id, dis_name: v.name });
        });
      }
      let obj = Object.assign(val, { treeList });
      this.getTableData(obj);
    },
    async getTableData(val) {
      this.formData = val;
      this.tableData = [];
      this.chartsData.xData = [];
      this.chartsData.unit = val.unit;
      this.chartsData.dataArr = [];
      this.barChartsData.unit = val.unit;
      let res = await api.formGetTabData({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        x_type: val.timeType.value,
        x_data: val.timeValue,
        key: val.typeKey,
        y_data: JSON.stringify(val.treeList),
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.tableData = res.data.data;
        this.tabHead.map((v) => {
          this.chartsData.dataArr.push({ name: v.prop, data: [] });
        });
        this.tableData.map((v) => {
          v.time = dateFtt(val.timeType.showTime, new Date(v.ts));
          this.chartsData.xData.push(v.time);
          for (let key in v) {
            let index = this.chartsData.dataArr.findIndex((v) => {
              return v.name == key;
            });
            if (index >= 0) {
              this.chartsData.dataArr[index].data.push(v[key]);
            }
          }
        });
        this.getBarChartsData();
      } else {
        this.$store.commit("SET_LOADING", false);
      }
    },
    getBarChartsData() {
      let newArr = JSON.parse(JSON.stringify(this.chartsData.dataArr));
      newArr.map((v) => {
        v.max = v.data.sort((a, b) => {
          return b - a;
        })[0];
        v.min = v.data.sort((a, b) => {
          return a - b;
        })[0];
        let tol = 0;
        v.data.map((item) => {
          tol += Number(item);
        });
        v.tol = Number(tol.toFixed(2));
        v.average =
          v.data.length == 0 ? 0 : Number((v.tol / v.data.length).toFixed(2));
      });
      this.barAllData = newArr;
      this.handleBarData();
    },
    handleBarData() {
      this.barChartsData.xData = [];
      this.barChartsData.yData = [];
      let arr = [];
      if (this.barActive == "average") {
        arr = this.barAllData.sort((a, b) => {
          return b.average - a.average;
        });
      } else if (this.barActive == "max") {
        arr = this.barAllData.sort((a, b) => {
          return b.max - a.max;
        });
      } else if (this.barActive == "min") {
        arr = this.barAllData.sort((a, b) => {
          return a.min - b.min;
        });
      }
      arr.slice(0, 5).map((v) => {
        this.barChartsData.xData.push(
          this.barActive == "average"
            ? v.average
            : this.barActive == "max"
            ? v.max
            : v.min
        );
        this.barChartsData.yData.push(v.name);
      });
    },
    exportExcel() {
      let tabHeader = [{ label: "时间", prop: "time" }].concat(this.tabHead);
      exportFile.xlsxFile(XLSX, this.excelTitle, {
        excel: exportExcelFun(tabHeader, this.tableData),
      });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.equipmentContrast {
  @include setFlexBetween;
  .leftMenuBox {
    @include setMenuWH;
  }
  .rightBox {
    @include setCenterWH;
    .chartsBox {
      width: 100%;
      height: 400px;
      margin-bottom: 12px;
      background: #fff;
      border-radius: 12px;
      @include setFlexBetween;
      .leftChart {
        width: 60%;
        height: 95%;
      }
      .rightChart {
        width: 39%;
        height: 95%;
      }
    }
    .tableBox {
      width: 100%;
      height: calc(100% - 432px);
      border-radius: 12px;
      background: #fff;
      padding-bottom: 20px;
      .comTitle {
        @include setFlexBetween;
        height: 42px;
        background-color: #fff;
      }
    }
  }
}
</style>